export default __webpack_public_path__ + "static/media/1-4.3f97c7a1.webp";